/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountDataRetentionInMonthsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountDataRetentionInMonthsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly dataRetentionInMonths: number } | null };


export const AccountDataRetentionInMonthsDocument = gql`
    query AccountDataRetentionInMonths($accountId: AccountId!) {
  account(id: $accountId) {
    id
    dataRetentionInMonths
  }
}
    `;

/**
 * __useAccountDataRetentionInMonthsQuery__
 *
 * To run a query within a React component, call `useAccountDataRetentionInMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDataRetentionInMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDataRetentionInMonthsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountDataRetentionInMonthsQuery(baseOptions: Apollo.QueryHookOptions<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables> & ({ variables: AccountDataRetentionInMonthsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>(AccountDataRetentionInMonthsDocument, options);
      }
export function useAccountDataRetentionInMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>(AccountDataRetentionInMonthsDocument, options);
        }
export function useAccountDataRetentionInMonthsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>(AccountDataRetentionInMonthsDocument, options);
        }
export type AccountDataRetentionInMonthsQueryHookResult = ReturnType<typeof useAccountDataRetentionInMonthsQuery>;
export type AccountDataRetentionInMonthsLazyQueryHookResult = ReturnType<typeof useAccountDataRetentionInMonthsLazyQuery>;
export type AccountDataRetentionInMonthsSuspenseQueryHookResult = ReturnType<typeof useAccountDataRetentionInMonthsSuspenseQuery>;
export type AccountDataRetentionInMonthsQueryResult = Apollo.QueryResult<AccountDataRetentionInMonthsQuery, AccountDataRetentionInMonthsQueryVariables>;